import request from '@/api/request'

// 获取咨询列表 pcgetonlinelist
export function getConsultingList(params) {
  return request({
    url: 'cases/pcgetonlinelist',
    method: 'get',
    params
  })
}

// 获取咨询详情
export function getConsultingDetail(params) {
  return request({
    url: 'zxonlineinfo',
    method: 'get',
    params
  })
}

// 接单
export function takeOrder(params) {
  return request({
    url: 'cases/zxonlineaccept',
    method: 'post',
    data: params
  })
}

// 发送回复
export function sendReply(params) {
  return request({
    url: 'cases/zxonlinereply',
    method: 'post',
    data: params
  })
}

// 完成咨询
export function completeConsulting(params) {
  return request({
    url: 'cases/zxonlinecomplete',
    method: 'post',
    data: params
  })
}

// 在线咨询更换接待律师 zxonlinechangelawyer
export function updateLawyer(params) {
  return request({
    url: 'cases/zxonlinechangelawyer',
    method: 'post',
    data: params
  })
}

// 删除问答记录 zxonlinedelchat
export function deleteChat(params) {
  return request({
    url: 'cases/zxonlinedelchat',
    method: 'post',
    data: params
  })
}

// 获取电话咨询列表 pcgetphonelist
export function getPhoneList(params) {
  return request({
    url: 'cases/pcgetphonelist',
    method: 'get',
    params
  })
}

// 电话咨询接单 zxphoneaccept
export function takePhoneOrder(params) {
  return request({
    url: 'cases/lawyergettelorder',
    method: 'post',
    data: params
  })
}

// 完成电话咨询 zxphonecomplete
export function completePhoneConsulting(params) {
  return request({
    url: 'cases/lawyertelcomplete',
    method: 'post',
    data: params
  })
}

export default {
  getConsultingList,
  getConsultingDetail,
  takeOrder,
  sendReply,
  completeConsulting,
  updateLawyer,
  deleteChat,
  getPhoneList,
  takePhoneOrder,
  completePhoneConsulting
} 